import {
    ApplicationInsights,
    ITelemetryPlugin
} from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin: ReactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights | undefined;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
    /**
     * Initialize the Application Insights class
     * @param {string} instrumentationKey - Application Insights Instrumentation Key
     * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
     * @return {void}
     */
    const initialize = (
        instrumentationKey: string | null | undefined,
        isDisabled: boolean
    ) => {
        try {
            if (!instrumentationKey) {
                throw new Error(
                    'Instrumentation key not provided in telemetry insights service'
                );
            }

            appInsights = new ApplicationInsights({
                config: {
                    disableTelemetry: isDisabled,
                    instrumentationKey: instrumentationKey,
                    maxBatchInterval: 0,
                    autoTrackPageVisitTime: true,
                    disableFetchTracking: false,
                    appId: 'faqbot-portal',
                    enableAutoRouteTracking: true,
                    extensions: [reactPlugin as ITelemetryPlugin]
                }
            });

            appInsights.loadAppInsights();
        } catch (error) {
            console.error('Error initializing Application Insights:', error);
        }
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
